<template>
  <component :is="entry.type + '-entry'" :gift="gift" :entry="entry" :configuratorId="configuratorId"
             :configuration="configuration" :enabled="enabled">
    <slot/>
  </component>
</template>

<script>
import StaticEntry from "./StaticEntry.vue";
import CheckEntry from "./CheckEntry.vue";
import CheckStaticEntry from "./CheckStaticEntry.vue";
import RadioEntry from "./RadioEntry.vue";
import FormEntry from "./FormEntry.vue";

export default {
  components: {StaticEntry, CheckEntry, CheckStaticEntry, RadioEntry, FormEntry},
  props: {
    entry: Object,
    configuratorId: String,
    configuration: Object,
    enabled: Boolean,
    gift: Object
  }
}
</script>